"use client";

import { useAuth } from "@/lib/auth-context";
import AlbumSidebar from "@/components/album-sidebar";

/**
 * Main content area with the album sidebar (own + shared) when authenticated.
 */
export default function AppShell({ children }: { children: React.ReactNode }) {
  const { user } = useAuth();
  const showSidebar = Boolean(user && !user.mustChangePassword);

  return (
    <div className="flex flex-1 pt-[50px] pb-[50px] min-h-0">
      {showSidebar && <AlbumSidebar />}
      <main
        className={
          "flex-1 min-w-0 overflow-x-hidden" + (showSidebar ? " ml-56" : "")
        }
      >
        {children}
      </main>
    </div>
  );
}
